import {
    createHandlerChainRunner,
    Handler,
    markSkipOnCompleteIfOnSuccessIsSet,
} from "@insite/client-framework/HandlerCreator";
import { deletePunchoutSecret } from "@TKCCP/Services/tkccpPunchoutService";

type HandlerType = Handler<{
    PunchOutSecretId: string;
    onSuccess?: () => void;
}>;

export const RequestRemovePunchOutSecret: HandlerType = async props => {
    await deletePunchoutSecret({
        id: props.parameter.PunchOutSecretId,
    });
};

export const ExecuteOnSuccessCallback: HandlerType = props => {
    markSkipOnCompleteIfOnSuccessIsSet(props);
    props.parameter.onSuccess?.();
};

export const DispatchLoadPunchOutSecret: HandlerType = props => {
    // if (props.parameter.reloadWishListLines) {
    //     props.dispatch(loadWishListLines());
    // }
};

export const chain = [RequestRemovePunchOutSecret, ExecuteOnSuccessCallback, DispatchLoadPunchOutSecret];

const deletePunchOutSecret = createHandlerChainRunner(chain, "DeletePunchoutSecret");
export default deletePunchOutSecret;
